import { render, staticRenderFns } from "./Cooperation.vue?vue&type=template&id=1c032828&scoped=true&"
import script from "./Cooperation.vue?vue&type=script&lang=js&"
export * from "./Cooperation.vue?vue&type=script&lang=js&"
import style0 from "./Cooperation.vue?vue&type=style&index=0&id=1c032828&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c032828",
  null
  
)

export default component.exports